// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3CiE2","label":"Labeled_label__D7zfB","divider":"Labeled_divider__2zGsI"};